import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .hasName()
    .publishable()
    .hasTimestamps()
    .make();

export default schema;
